import SalesManagementWHMB from './SalesManagementWHMB.vue'

export default SalesManagementWHMB


// WEBPACK FOOTER //
// ./src/pages/salesManagement/whmb/index.js